import { render } from "./ExitIcon.vue?vue&type=template&id=fd4c4c90"
import script from "./ExitIcon.vue?vue&type=script&lang=js"
export * from "./ExitIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__